export default "__VITE_ASSET__9U2X8LTl__"